import React from "react";
import ValueChecker from "../model/ValueChecker";
import {ValidationRuleNames} from "../rules/ValidationRule";
import ValidationRuleBytes, {ValidationRuleBytesProps} from "../rules/ValidationRuleBytes";
import StringUtil from "../../../utils/StringUtil";

export interface UIValidatorProps {
    rules?: (ValidationRuleNames | ((value: any) => string | undefined) | null)[] | null;
    bytes?: ValidationRuleBytesProps;
}

export const useUIValidator = (props: UIValidatorProps) => {
    const [valueChecker, setValueChecker] = React.useState<ValueChecker>(new ValueChecker(props.rules));
    const [errorClassName, setClassName] = React.useState<string>("");
    const [element, setElement] = React.useState<HTMLElement | null>();
    const [required, setRequired] = React.useState(false);
    const className = "tf-error";

    React.useEffect(() => {
        if (props.bytes != null) {
            valueChecker.addRule(new ValidationRuleBytes(props.bytes));
        }
    }, [props.bytes]);

    React.useEffect(() => {
        // if (props.rules != null && props.rules.indexOf("required") !== -1) {
        //     setRequired(true);
        // }
        setClassName(valueChecker.valid ? "" : className);

        if (valueChecker && element && StringUtil.isNotEmpty(element.ariaInvalid)) {
            if (valueChecker.valid) {
                element?.classList.remove(className)
                element?.setAttribute('data-validation-message', "");
            }
            else {
                element?.classList.add(className)
                element?.setAttribute('data-validation-message', valueChecker.message!);
            }
        }
    });

    return {
        required,
        valueChecker,
        errorClassName,
        setElement
    };
}
export default useUIValidator;
